import script from "./licenseFormMixins.vue?vue&type=script&lang=js"
export * from "./licenseFormMixins.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__